export function scrollUtilityClass() {
  const topOffset = 300;

  function handlePosition() {
    if (window.scrollY <= 0) {
      document.documentElement.classList.remove("not-top");
    } else {
      document.documentElement.classList.add("not-top");
    }

    if (window.scrollY > topOffset) {
      document.documentElement.classList.add("top-offset-reached");
    } else {
      document.documentElement.classList.remove("top-offset-reached");
    }
  }

  let lastScrollTop = 0;
  function handleDirection() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      document.documentElement.classList.add("scroll-down");
      document.documentElement.classList.remove("scroll-up");
    } else if (currentScrollTop < lastScrollTop) {
      document.documentElement.classList.add("scroll-up");
      document.documentElement.classList.remove("scroll-down");
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  handlePosition();

  window.addEventListener(
    "scroll",
    () => {
      handlePosition();
      handleDirection();
    },
    { passive: true }
  );
}
